import { getTargetOrigin } from "./configuration";
import { relayPostMessageToRcIframe } from "../modules/realityCheckIframe";

const isInIframe = ((): boolean => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
})();

/**
 * @internal
 * Posts a postMessage to parent and possibly rc iframe
 * @param message
 */
export const postToOperator = (message: unknown): void =>
{
    if (message === undefined) {
        return;
    }
    
    const targetOrigin = getTargetOrigin();
    
    relayPostMessageToRcIframe(message, targetOrigin);

    if (isInIframe) {
        window.parent.postMessage(message, targetOrigin);
    }
};
